export const normalizeFormStyles = (theme) => ({
  link: {
    margin: '0 0.1em',
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
})
